export default "__VITE_ASSET__2HZLu2fq__"